import { ChevronRightIcon } from "@chakra-ui/icons";
import { Flex } from "@chakra-ui/react";
import { PaymentStep, usePaymentStore } from "../../payment";

const CheckoutStep = ({
  step,
  label,
}: {
  step: PaymentStep;
  label: string;
}) => {
  const currentStep = usePaymentStore((state) => state.currentStep);
  return (
    <>
      <span
        className={
          step == currentStep ? "text-primary font-bold" : "text-neutral-500"
        }
      >
        {label}
      </span>
    </>
  );
};

const CheckoutBreadcrumb = () => {
  const steps = [
    { step: PaymentStep.SELECT_ITEMS, label: "Cart" },
    { step: PaymentStep.CHECKOUT, label: "Details & Payment" },
    { step: PaymentStep.COMPLETE, label: "Complete" },
  ];
  const lastIdx = steps.length - 1;
  return (
    <Flex
      flexGrow={1}
      alignItems="center"
      gap={4}
      display={["none", "none", "flex"]}
    >
      {steps.map((step, i) => (
        <Flex alignItems="center" gap={4} key={i}>
          <CheckoutStep {...step} />
          {i !== lastIdx && (
            <ChevronRightIcon
              cursor="pointer"
              boxSize="1rem"
              color="neutral.300"
            />
          )}
        </Flex>
      ))}
    </Flex>
  );
};

export default CheckoutBreadcrumb;
